(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7051],{

/***/ 64778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./affiliates1.png": 64833,
	"./affiliates2.png": 99294,
	"./article1.png": 94590,
	"./article2.png": 1923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64778;

/***/ }),

/***/ 11125:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[page]",
      function () {
        return __webpack_require__(28737);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates1.c0070cc6.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAM1BMVEX+5d704NX+7+v7+vjd5M7r5+TP2rz/5+KU2pOk2J3Oy8zi3+nGxcPq4dHf4tPZz+7T0dDOjqjRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nB3IQRKAIBAEsQYWZhZQ/P9rLc0xgGLw0ZUeApW086+0XYDa74gKauvM1YT6ns/uegEgZAE8oolrqQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 99294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates2.7641f663.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAMFBMVEXY9P7Y8vbm7db9yTrn+PnLzc/l57jr4Jry1m/3+PjExsbX3N3g3uji5sT30FzUzu5ACGK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB3ISQ4AIQzEQKeTsMP8/7cj8MkqwIqMm3Z9Y9W9PGl+2qUISQH09eXqwMyRY/IDFB0A3NgNDvgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 94590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/article1.6820bc2f.png","height":460,"width":694,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAMFBMVEUSJ0slOFk9U3Q1SWwdMVRZaIEGHUNPZ4hGXYJlfJoDFzwrQGNyiqrAx9KLlKbZ2+SrMHKJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nAXBhwEAIAzDMKcDyv7/WySQ7VEeNPIkARN/FwVNSpNgWfXRnQ8QkQC4xF0Z1gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 1923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/article2.ad41d0ad.png","height":458,"width":726,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAHlBMVEXqwgPluwTyzQDuxwHasw/Ooh/XsC3Rr1G9m2O/p50bfbN2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKElEQVR4nCXJwQ0AIAwDsQtJW9h/YYTw16zHNgbQNEln6myEFFX9Al0KGABqPGLlSwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 18954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43138);





const BlogCard = (param)=>{
    let { blogImage , image , imageURL , imageWidth ="w-full md:h-[250px] lg:h-[367px] xl:h-[370px]" , title , genre , date , owner , desc , blogUrl , genreColor , customTitle , imageBorders , localAsset =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: blogUrl,
        target: "_blank",
        className: "group w-full flex flex-col gap-6 text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex items-center justify-center mx-auto",
                children: [
                    (imageURL || image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[367px] bg-surface-light ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: imageURL ? imageURL : localAsset ? __webpack_require__(64778)("./".concat(image)) : "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_4__.BASE_ASSETS_URL, "/v2/articles/").concat(image),
                            alt: title,
                            width: 100,
                            height: 100,
                            className: "w-full h-full object-cover"
                        })
                    }),
                    blogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[367px] bg-surface-light ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "".concat(blogImage),
                            alt: title,
                            width: 100,
                            height: 100,
                            className: "w-full h-full object-cover"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-left font-bold md:px-0 px-2 ".concat(customTitle ? customTitle : "text-xl leading-snug lg:text-[28px] md:leading-[36px]"),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:px-0 px-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-left md:text-[22px] md:leading-[32px] text-base leading-snug font-medium text-gray-600",
                        children: desc
                    }),
                    owner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-start items-center gap-2 mt-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                width: 48,
                                height: 48,
                                src: owner === null || owner === void 0 ? void 0 : owner.img,
                                alt: "Owner",
                                className: "rounded-full"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "md:text-xl text-base font-semibold text-gray-800",
                                        children: owner === null || owner === void 0 ? void 0 : owner.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "md:text-base text-sm font-semibold text-gray-500",
                                        children: owner === null || owner === void 0 ? void 0 : owner.title
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 46945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




// import { BASE_ASSETS_URL } from "../../../constants/constants";
const BlogCard2 = (param)=>{
    let { blogImage , // image,
    // imageWidth = "w-full md:h-[250px] lg:h-[367px] xl:h-[370px]",
    title , genre , date , blogUrl , // genreColor,
    customTitle , // imageBorders,
    // localAsset = false,
    meta_description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: blogUrl,
        target: "_blank",
        className: "w-full flex flex-col  rounded-3xl overflow-hidden bg-white hover:bg-surface  transition-all duration-500 ease-in-out border border-surface-dark",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full flex items-center justify-center mx-auto h-[280px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "".concat(blogImage),
                    alt: title,
                    width: 100,
                    height: 100,
                    className: "w-full h-full object-cover "
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: " md:px-8 px-6 py-8 w-full ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between items-centser gap-4 mb-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " text-base font-semibold text-gray-600",
                                children: genre
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: date
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-xl lg:text-[20px] leading-[26px] font-semibold ".concat(customTitle ? customTitle : ""),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-base text-gray-700 mt-3 ",
                        children: meta_description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard2);


/***/ }),

/***/ 15409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);




const Rating = (param)=>{
    let { rate  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center gap-4 md:gap-6 flex-wrap",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center gap-1",
                children: Array.from({
                    length: rate
                }, (_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/landing-page/star.svg"),
                        width: 20,
                        height: 20,
                        alt: "star"
                    }, index))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "text-xl",
                children: [
                    "Rated ",
                    rate,
                    "/5 - From over 2K reviews."
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Rating);


/***/ }),

/***/ 59183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46687);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71631);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69274);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);









const CtaOne = (param)=>{
    let { heading1 , heading2 , heading3 , paragraph , paragraphStyling , buttonsStyling , buttonPrimaryText , buttonPrimaryUrl , buttonPrimaryIcon , buttonPrimaryBorderShadow , buttonPrimaryNewTab , buttonPrimaryBg , buttonSecondaryText , buttonSecondaryUrl , buttonSecondaryIcon , buttonSecondaryNewTab , signaturePopupOpen  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        open: false,
        mode: "register"
    });
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const isSignaturePage = signaturePopupOpen;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .is1DollarTrialCampaign */ .Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-7 sm:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPopupOpen: signaturePopup.open && isSignaturePage,
                mode: signaturePopup.mode,
                setIsPopupOpen: (value)=>setSignaturePopup((prev)=>({
                            ...prev,
                            open: value
                        })),
                setMode: (mode)=>setSignaturePopup((prev)=>({
                            ...prev,
                            mode: mode
                        }))
            }),
            heading1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl",
                children: heading2
            }),
            heading3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "font-bold text-2xl sm:text-3xl",
                children: heading3
            }),
            paragraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg sm:text-xl ".concat(paragraphStyling),
                children: paragraph
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ".concat(buttonsStyling && buttonsStyling),
                children: [
                    buttonPrimaryText && (isSignaturePage ? is1DollarTrialCampaignState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .Button1 */ .g, {
                        btnText: buttonPrimaryText,
                        bgColor: buttonPrimaryBg || "bg-violet-500",
                        textColor: "text-white",
                        border: "border border-violet-500 ",
                        showLoading: false,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {}),
                        borderShadow: buttonPrimaryBorderShadow !== null && buttonPrimaryBorderShadow !== void 0 ? buttonPrimaryBorderShadow : true,
                        px: "px-5"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimaryDiv */ .gf, {
                        buttonText: buttonPrimaryText,
                        onclick: ()=>setSignaturePopup((prev)=>({
                                    ...prev,
                                    open: true
                                })),
                        buttonUrl: buttonPrimaryUrl,
                        icon: buttonPrimaryIcon,
                        borderShadow: buttonPrimaryBorderShadow,
                        newTab: buttonPrimaryNewTab,
                        bgColor: buttonPrimaryBg
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary */ .IS, {
                        buttonText: buttonPrimaryText,
                        buttonUrl: buttonPrimaryUrl,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {})
                    })),
                    buttonSecondaryText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonSecondaryBorder */ .AL, {
                        buttonText: buttonSecondaryText,
                        buttonUrl: buttonSecondaryUrl
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CtaOne);


/***/ }),

/***/ 39569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ featuredBlogs; }
/* harmony export */ });
const featuredBlogs = [
    {
        image: "",
        imageURL: "https://boloforms.ghost.io/content/images/2025/07/ChatGPT-Image-Jul-2--2025--05_49_16-PM.png",
        title: "The 5 Best AI Contract Review Software Tools for 2025",
        genreColor: "bg-red-100",
        genre: "CLM",
        date: "Jul 21, 2025",
        blogUrl: "https://www.bolosign.com/blog/the-5-best-ai-contract-review-software-tools-for-2025/",
        desc: "Compare the best AI contract review tools for 2025. See features, benefits, and practical tips to implement them at scale. Explore BoloSign’s unified solution.",
        owner: {
            img: "https://i.imgur.com/CbNehZg.png",
            name: "Paresh Deshmukh",
            title: "Co-Founder, BoloSign"
        }
    },
    {
        image: "",
        imageURL: "https://boloforms.ghost.io/content/images/2025/07/ChatGPT-Image-Jul-4--2025--05_10_14-PM.png",
        title: "Are Clickwrap Agreements Legally Binding?",
        genreColor: "bg-green-100",
        genre: "CLM",
        date: "Jul 21, 2025",
        blogUrl: "https://www.bolosign.com/blog/are-clickwrap-agreements-legally-binding/",
        desc: "Learn if clickwrap agreements are legally binding, how they work, and key best practices for enforceability.",
        owner: {
            img: "https://i.imgur.com/CbNehZg.png",
            name: "Paresh Deshmukh",
            title: "Co-Founder, BoloSign"
        }
    }
];



/***/ }),

/***/ 28737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59183);
/* harmony import */ var _components_Blog_BlogCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18954);
/* harmony import */ var _components_Blog_Rating__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15409);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46687);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10447);
/* harmony import */ var _components_Blog_BlogCard2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46945);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56475);
/* harmony import */ var _constants_blogs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39569);














const cardsColor = {
    signature: "bg-green-100",
    contracts: "bg-red-100"
};
function Blogs(props) {
    const { posts , pagination  } = props;
    // console.log("POSTS 2", posts);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    if (!posts) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex justify-center items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-2xl font-bold",
                children: "No Posts Found"
            })
        });
    }
    const handlePush = (link)=>{
        router.push(link);
    };
    const schema1 = {
        "@context": "https://schema.org/",
        "@type": "WebSite",
        name: "Latest Blogs Of Boloforms",
        url: "https://www.boloforms.com/blog/",
        potentialAction: {
            "@type": "SearchAction",
            target: "https://www.boloforms.com/blog/{search_term_string}",
            "query-input": "required name=search_term_string"
        }
    };
    const schema2 = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.boloforms.com"
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "Latest Blogs",
                item: "https://www.boloforms.com/blog/"
            }
        ]
    };
    const schema3 = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Boloforms",
        alternateName: "Workflow Automated Software",
        url: "https://www.boloforms.com/blog/",
        logo: "https://www.boloforms.com/_next/static/media/logo-text.e6f7617c.svg",
        sameAs: [
            "https://www.facebook.com/boloforms/",
            "https://twitter.com/BoloForms",
            "https://www.youtube.com/channel/UCjbA2sUd7jxdtiuwadt7VKg",
            "https://www.boloforms.com/blog/"
        ]
    };
    var _cardsColor_post_primary_tag_name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "BoloSign - AI for Smart Contract Management | Blogs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://bolosign.com/blog/page/".concat(pagination.page)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign - AI for Smart Contract Management | Blogs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://bolosign.com/blog/page/".concat(pagination.page)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign - AI for Smart Contract Management | Blogs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/blog/page/".concat(pagination.page)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-screen-xl mx-auto md:px-8 px-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full max-w-screen-mxl mx-auto px-4 md:px-8 xxl:px-0 flex flex-col md:flex-row justify-between items-center md:gap-6 lg:gap-20 mxl:gap-40",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    heading2: "Take a Look at Our Featured Articles",
                                    paragraph: "These software solutions provide centralized platform planning and monitoring task lifecycle."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex-1 flex flex-col w-full gap-10 md:gap-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex gap-2 xs:gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_10__/* .CLMButtonPrimary */ .IS, {
                                                buttonText: "Get Started",
                                                buttonUrl: "https://signature.boloforms.com/register?from=WEBSITE_BLOG_PAGE_HERO".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__/* .createUTMQueryParams */ .T0)({
                                                    from: "WEBSITE_BLOG_PAGE_HERO"
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_10__/* .CLMButtonSecondaryBorder */ .AL, {
                                                buttonText: "Buy Now",
                                                buttonUrl: "/signature/pricing"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_Rating__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            rate: 4.7
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full py-20 flex flex-col md:flex-row gap-6 sm:max-w-[80%] md:max-w-screen-mxl mx-auto",
                        children: _constants_blogs__WEBPACK_IMPORTED_MODULE_11__/* .featuredBlogs.map */ .X.map((card, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_BlogCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                ...card
                            }, index))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full max-w-screen-mxl mx-auto py-16 flex flex-col gap-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    heading2: "See Latest Articles"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full sm:max-w-[80%] md:max-w-full mx-auto",
                                children: posts.map((post, index)=>{
                                    var _post_primary_tag, _post_primary_tag1, _post_primary_tag2;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_BlogCard2__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        blogImage: post.feature_image,
                                        title: post.title,
                                        genre: (post === null || post === void 0 ? void 0 : (_post_primary_tag = post.primary_tag) === null || _post_primary_tag === void 0 ? void 0 : _post_primary_tag.name.charAt(0).toUpperCase()) + (post === null || post === void 0 ? void 0 : (_post_primary_tag1 = post.primary_tag) === null || _post_primary_tag1 === void 0 ? void 0 : _post_primary_tag1.name.slice(1)) || "BoloForms",
                                        date: new Date(post.published_at).toShortFormat(),
                                        blogUrl: "/blog/".concat(post.slug),
                                        customTitle: "text-xl",
                                        imageBorders: false,
                                        genreColor: (_cardsColor_post_primary_tag_name = cardsColor[post === null || post === void 0 ? void 0 : (_post_primary_tag2 = post.primary_tag) === null || _post_primary_tag2 === void 0 ? void 0 : _post_primary_tag2.name]) !== null && _cardsColor_post_primary_tag_name !== void 0 ? _cardsColor_post_primary_tag_name : "bg-red-100",
                                        meta_description: post.meta_description
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-screen-mxl mx-auto flex justify-center items-center gap-1 my-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        "aria-label": "Previous",
                        onClick: ()=>{
                            handlePush((pagination === null || pagination === void 0 ? void 0 : pagination.prev) ? "/blog/page/".concat(pagination === null || pagination === void 0 ? void 0 : pagination.prev) : "/blog/page/$".concat(pagination === null || pagination === void 0 ? void 0 : pagination.page, "/#"));
                        },
                        disabled: !(pagination === null || pagination === void 0 ? void 0 : pagination.prev),
                        className: "".concat((pagination === null || pagination === void 0 ? void 0 : pagination.prev) ? "bg-accent-purple text-white" : " cursor-not-allowed opacity-50 bg-gray-200", " flex justify-center items-center text-lg  font-semibold px-6 h-12  rounded-full "),
                        children: "Prev"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: " text-gray-600 text-lg flex justify-center items-center font-semibold px-4 h-12 gap-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    pagination === null || pagination === void 0 ? void 0 : pagination.page,
                                    " of"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: ()=>{
                                    handlePush("/blog/page/".concat(pagination === null || pagination === void 0 ? void 0 : pagination.pages));
                                },
                                children: pagination === null || pagination === void 0 ? void 0 : pagination.pages
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        "aria-label": "Next",
                        onClick: ()=>{
                            handlePush((pagination === null || pagination === void 0 ? void 0 : pagination.next) ? "/blog/page/".concat(pagination === null || pagination === void 0 ? void 0 : pagination.next) : "/blog/page/".concat(pagination === null || pagination === void 0 ? void 0 : pagination.page, "/#"));
                        },
                        disabled: !(pagination === null || pagination === void 0 ? void 0 : pagination.next),
                        className: "".concat((pagination === null || pagination === void 0 ? void 0 : pagination.next) ? "bg-accent-purple text-white" : " cursor-not-allowed opacity-50 bg-gray-200", "  flex justify-center items-center text-lg  font-semibold px-6 h-12  rounded-full"),
                        children: "Next"
                    })
                ]
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Blogs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(11125); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);